import { render, staticRenderFns } from "./CharacterLook.vue?vue&type=template&id=8d1c6d02&"
import script from "./CharacterLook.vue?vue&type=script&lang=js&"
export * from "./CharacterLook.vue?vue&type=script&lang=js&"
import style0 from "./CharacterLook.vue?vue&type=style&index=0&id=8d1c6d02&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports